export const REDUCER_NAME = "competitionCup";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONCUP = `${REDUCER_NAME}/SET_COMPETITIONCUP`;
export const RESET_COMPETITIONCUP = `${REDUCER_NAME}/RESET_COMPETITIONCUP`;

export const STATUS_POSTPONED = "POSTPONED";
